import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ArticleCard from "../components/ArticleCard";
import { api } from "../lib/api";
import { Search } from "lucide-react";

export default function SearchPage() {
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const [input, setInput] = useState(q);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = `Recherche : ${q} — Le Véridique`;
    setInput(q);
    if (!q) { setItems([]); setTotal(0); return; }
    setLoading(true);
    api.get("/articles", { params: { search: q, limit: 60 } })
      .then((r) => { setItems(r.data.articles || []); setTotal(r.data.total || 0); })
      .finally(() => setLoading(false));
  }, [q]);

  const submit = (e) => {
    e.preventDefault();
    setParams({ q: input.trim() });
  };

  return (
    <div className="App">
      <Header />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <form onSubmit={submit} className="max-w-2xl mb-8">
          <div className="flex items-center border-b-2 border-[#0F172A] pb-2">
            <Search size={22} className="text-slate-400 mr-3" />
            <input value={input} onChange={(e) => setInput(e.target.value)} autoFocus
              data-testid="search-page-input"
              placeholder="Rechercher par titre, contenu, auteur, mot-clé…"
              className="flex-1 bg-transparent outline-none font-headline text-2xl text-[#0F172A] placeholder:text-slate-300" />
          </div>
        </form>

        {q && <p className="meta-label text-slate-500 mb-6" data-testid="search-results-count">{total} résultat{total > 1 ? "s" : ""} pour « {q} »</p>}
        {loading && <div className="py-16 text-center meta-label text-slate-400">Recherche…</div>}
        {!loading && q && items.length === 0 && (
          <p className="font-body text-slate-500 py-16 text-center">Aucun article ne correspond à votre recherche.</p>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((a) => <ArticleCard key={a.id} article={a} />)}
        </div>
      </main>
      <Footer />
    </div>
  );
}
